module.exports = __webpack_public_path__ + "static/vector_grey-4b93efeddffd9a9582f74eb655a8e8ac.png";